export default {
  formId: 'externalTransactionConfig',
  formField: {
    siteId: {
      name: 'site',
      label: 'Select Site',
      requiredErrorMsg: 'Site is required',
      type: 'select',
      data: []
    },
    quantity: {
      name: 'quantity',
      label: 'Quantity',
      requiredErrorMsg: 'Quantity is required',
      type: 'text',
    },
    unitPrice: {
      name: 'unit_price',
      label: 'Unit Price',
      requiredErrorMsg: 'Unit Price is required',
      type: 'text',
    },
    amount: {
      name: 'amount',
      label: 'Amount',
      requiredErrorMsg: 'Amount is required',
      type: 'text',
    },
    vehicleNumber: {
      name: 'vehicle_number',
      label: 'Vehicle Number',
      requiredErrorMsg: 'Vehicle Number is required',
      invalidErrorMsg: 'Invalid Vehicle Number',
      type: 'text',
    },
    dateTime: {
      name: 'date_time',
      label: 'Date Time',
      requiredErrorMsg: 'Date Time is required',
      type: 'date',
    },
    odometerEntry: {
      name: 'odometer_entry',
      label: 'Odometer Entry',
      requiredErrorMsg: 'Odometer Entry is required',
      type: 'text',
    }
  }
};
